var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionRemoveDark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_action_remove_dark"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 120 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5859 12L5.29297 6.70712L6.70718 5.29291L12.0001 10.5858L17.293 5.29291L18.7072 6.70712L13.4143 12L18.7072 17.2929L17.293 18.7071L12.0001 13.4142L6.70718 18.7071L5.29297 17.2929L10.5859 12Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionRemoveDark);
export default __webpack_public_path__ + "static/media/ic_action_remove_dark.3be6e8c73f591d4829b8f2df866d3eb8.svg";
export { ForwardRef as ReactComponent };